import { render, staticRenderFns } from "./HipsterCheckbox.vue?vue&type=template&id=2281b1bc&scoped=true&"
import script from "./HipsterCheckbox.vue?vue&type=script&lang=ts&"
export * from "./HipsterCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./HipsterCheckbox.vue?vue&type=style&index=0&id=2281b1bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281b1bc",
  null
  
)

export default component.exports